import z from "zod";

const translationPath = "page.settings.crm.ticketAutoInactivityRules.errors.";

const ticketTypeSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().optional().nullable(),
  },
  { invalid_type_error: translationPath + "ticket_type" }
);

const ticketChannelStepStatusSchema = z.object({
  code: z.string().optional(),
  id: z.string(),
  name: z.string(),
});

const ticketChannelStepSchema = z.object({
  id: z.string(),
  name: z.string(),
  status: ticketChannelStepStatusSchema,
});

const ticketChannelSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  { invalid_type_error: translationPath + "ticket_channel" }
);

const ticketWorkspaceSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().optional().nullable(),
});

export const ticketAutoInactiveRuleSchema = z
  .object({
    ticketType: ticketTypeSchema,
    ticketChannelStep: ticketChannelStepSchema.nullable(),
    ticketChannel: ticketChannelSchema
      .nullable()
      .refine((val) => val, translationPath + "ticket_channel"),
    ticketWorkspace: ticketWorkspaceSchema
      .optional()
      .nullable()
      .refine((val) => val, translationPath + "ticket_workspace"),
    initialDate: z.date({
      invalid_type_error: translationPath + "initial_date",
    }),
    endDate: z.date({ invalid_type_error: translationPath + "end_date" }),
    minutes: z.string().min(1, { message: translationPath + "minutes" }),
    message: z.string().nullish(),
  })
  .superRefine((val, ctx) => {
    if (Number(val.minutes) > 1440) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["minutes"],
        message: translationPath + "max_minutes",
      });
    }
    if (val.endDate < val.initialDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["endDate"],
        message: translationPath + "end_date_less",
      });
    }
  });

export type TTicketAutoInactiveRuleForm = z.infer<
  typeof ticketAutoInactiveRuleSchema
>;
